"use client";

import Button from "@/app/pwa/components/Button";
import { ClubImage } from "@/app/pwa/components/TeamImage";
import { Club } from "@/sources/kicker-amateur/types";
import { useEffect, useState } from "react";
import IconShare from "@/assets/icon/share.svg";
import IconClose from "@/assets/icon/close.svg";

declare global {
  interface Navigator {
    standalone?: boolean;
  }
}
interface InstallBannerDisplayProps {
  pwa: Club;
}
export function InstallBannerDisplay({ pwa }: InstallBannerDisplayProps) {
  const [isClosed, setIsClosed] = useState<boolean | undefined>();
  useEffect(() => {
    if (localStorage.getItem("InstallBanner")) {
      setIsClosed(true);
    } else {
      setIsClosed(false);
    }
  }, []);

  const { isIos, isAndroid, isPwa } = useIsAndroidOrIos();
  // return true ? (
  return (isAndroid || isIos) && !isClosed && !isPwa ? (
    <div className="pb-safe-area-inset-bottom fixed bottom-2 left-2 right-2 z-50 motion-safe:animate-slide-install-banner translate-y-full opacity-0">
      <div className="flex gap-2 text-gray-50 bg-gray-900/80 p-4 text-center items-center justify-between rounded-lg shadow-lg backdrop-blur-sm">
        <ClubImage club={pwa} size="12" />
        <div className="block">
          <div className="text-sm font-bold mb-1">Vereinsheim-App installieren</div>
          {isAndroid ? (
            <div className="leading-tight">
              Tippe auf das Menü-Icon und wähle &bdquo;Zum Startbildschirm hinzufügen&ldquo;
            </div>
          ) : isIos ? (
            <div className="leading-tight">
              Wähle <IconShare className="h-4 w-4 inline-block align-baseline" /> und &bdquo;Zum Home-Bildschirm&ldquo;
            </div>
            
          ) : null}
        </div>
        <div>
          <Button
            onClick={() => {
              localStorage.setItem("InstallBanner", "Closed");
              setIsClosed(true);
            }}
            color="link-muted"
            // className="px-2"
          >
            <IconClose />
          </Button>
        </div>
      </div>
    </div>
  ) : null;
}

function useIsAndroidOrIos() {
  const [isAndroid, setIsAndroid] = useState<boolean | null>(null);
  const [isIos, setIsIos] = useState<boolean | null>(null);
  const [isPwa, setIsPwa] = useState<boolean | null>(null);
  useEffect(() => {
    const agent = window.navigator.userAgent;
    let checkPwa = false
    if (agent.includes("Android")) {
      setIsAndroid(true);
      checkPwa = true
    } else {
      setIsAndroid(false);
    }
    if (agent.includes("iPhone") || agent.includes("iPad")) {
      setIsIos(true);
      checkPwa = true
    } else {
      setIsIos(false);
    }

    if (checkPwa && (window?.matchMedia('(display-mode: standalone)').matches || window?.navigator?.standalone)) {
      setIsPwa(true);
    } else {
      setIsPwa(false);
    }
  }, []);

  return { isAndroid, isIos, isPwa };
}
